import type { ApiEstimate } from "@/lib/api/types"

// Consumer intake v2 — shared vocabulary for the public flow.
//
// `surface` = how the consumer arrived (attributed on the lead, drives the
// SURFACE_RULES table in surfaces.ts). `device` = where the flow is running
// right now; desktop hands off to a phone via QR/SMS (the `handoff` phase).

export type IntakeSurface = "link" | "qr" | "sms" | "embed" | "widget" | "kiosk"
export type IntakeDevice = "phone" | "desktop"

export const INTAKE_SURFACES: readonly IntakeSurface[] = [
  "link", "qr", "sms", "embed", "widget", "kiosk",
]

export function isIntakeSurface(value: unknown): value is IntakeSurface {
  return typeof value === "string" && (INTAKE_SURFACES as readonly string[]).includes(value)
}

// Phase machine: contact → [handoff (desktop)] → photos → extras → reveal →
// offer → booking? → done. Extras run while the AI reads the photos; the
// reveal lands after the last extra.
export type Phase =
  | "contact"
  | "handoff"
  | "photos"
  | "extras"
  | "reveal"
  | "offer"
  | "booking"
  | "done"

export type ExtrasStep = "vehicle" | "situation" | "insurance" | "reach"

// How the flow was entered. `continuation` is a phone that scanned the QR /
// tapped the SMS link for a lead created elsewhere (?c=<token>) — the flow
// hydrates from the estimate and skips contact.
export type Entry =
  | { kind: "fresh" }
  | { kind: "resume" }
  | { kind: "continuation"; estimate: ApiEstimate }
